<template>
  <div>
    <Table stripe :columns="columns" :data="otherServiceFeeList"></Table>
  </div>
</template>

<script>
export default {
  props: ['otherServiceFeeList'],
  data() {
    return {
      columns: [
        {
          title: '申请时间',
          width: 200,
          align: 'center',
          key: 'createDate'
        },
        {
          title: '项目',
          width: 100,
          align: 'center',
          key: 'project'
        },
        {
          title: '原价',
          width: 100,
          align: 'center',
          key: 'charge',
          render: (h, param) => {
            return h('div', {}, `¥${(param.row.charge/100).toFixed(2)}`)
          }
          
        },
        {
          title: '优惠',
          width: 100,
          align: 'center',
          key: 'discount',
          render: (h, param) => {
            return h('div', {}, `¥${(param.row.discount/100).toFixed(2)}`)
          }
        },
        {
          title: '应付',
          width: 100,
          align: 'center',
          key: 'userPay',
          render: (h, param) => {
            return h('div', {}, `¥${(param.row.userPay/100).toFixed(2)}`)
          }
        },
        {
          title: '支付渠道/方式',
          width: 150,
          align: 'center',
          key: 'payType'
        },
        {
          title: '流水号',
          width: 200,
          align: 'center',
          key: 'otherNo'
        },
        {
          title: '支付信息',
          width: 200,
          align: 'center',
          render: (h,param) => {
            return ('div', [
              h('p', {}, param.row.payName),
              h('p', {}, param.row.payDate),
            ])
          }
        },
        {
          title: '备注',
          width: 260,
          align: 'center',
          render: (h,param) => {
            return ('div', [
              h('p', {}, param.row.cleanOrderNo),
              h('p', {}, param.row.createDate),
            ])
          }
        },
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/order/order_detail/value-add-services.vue